import { useEffect, useState } from 'react'
import { Caption, COLORS } from './ui'

const DOMAINS = [
  { label: 'Classification', color: '#818cf8', models: ['ViT', 'ConvNeXt', 'EfficientNet'] },
  { label: 'Detection', color: '#a78bfa', models: ['YOLO-World', 'RT-DETR', 'Grounding DINO'] },
  { label: 'Segmentation', color: '#f472b6', models: ['SAM 2', 'Mask2Former'] },
  { label: 'Self-Supervised', color: '#4ade80', models: ['DINOv2', 'MAE'] },
  { label: 'Depth / 3D', color: '#22d3ee', models: ['Depth Anything v2', 'Gaussian Splatting'] },
  { label: 'Generative', color: '#fb7185', models: ['FLUX', 'SD3', 'Sora'] },
  { label: 'Multimodal / VLM', color: '#c084fc', models: ['GPT-4o', 'Gemini', 'Claude'] },
  { label: 'OCR / Docs', color: '#fb923c', models: ['TrOCR', 'PaddleOCR'] },
  { label: 'Tracking', color: '#facc15', models: ['ByteTrack', 'SAM 2'] },
  { label: 'Robotics / VLA', color: '#86efac', models: ['RT-2', 'OpenVLA', 'π0'] },
  { label: 'Medical', color: '#34d399', models: ['MedSAM', 'nnU-Net'] },
  { label: 'Autonomous', color: '#60a5fa', models: ['Tesla Vision', 'Waymo'] },
]

export function Universe2D() {
  const [mobile, setMobile] = useState(() => window.innerWidth < 768)
  useEffect(() => {
    const handler = () => setMobile(window.innerWidth < 768)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto',
      alignItems: 'center', justifyContent: 'center', gap: mobile ? 4 : 8, padding: mobile ? '78px 14px 90px' : '84px 24px 100px',
      fontFamily: "'General Sans', system-ui, sans-serif", textAlign: 'center', color: COLORS.text,
    }}>
      <div style={{ fontSize: mobile ? 18 : 'clamp(22px,3vw,32px)', fontWeight: 800 }}>The Computer Vision Universe</div>
      <div style={{ fontSize: mobile ? 9.5 : 12, letterSpacing: '0.1em', color: COLORS.textFaint, fontFamily: "'JetBrains Mono', ui-monospace, monospace", marginBottom: mobile ? 6 : 14 }}>
        12 DOMAINS · 2026 MODEL FAMILIES
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: mobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(160px, 1fr))', gap: mobile ? 6 : 10,
        maxWidth: 900, width: '100%',
      }}>
        {DOMAINS.map(d => (
          <div key={d.label} style={{
            background: 'rgba(10,10,26,0.5)', border: `1px solid ${d.color}40`, borderRadius: mobile ? 8 : 12,
            padding: mobile ? '8px 9px' : '12px 14px', textAlign: 'left', backdropFilter: 'blur(8px)',
            boxShadow: `0 0 24px ${d.color}10`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: mobile ? 4 : 8 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: d.color, boxShadow: `0 0 8px ${d.color}` }} />
              <span style={{ fontSize: mobile ? 11 : 14, fontWeight: 700, color: d.color }}>{d.label}</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {d.models.map(m => (
                <span key={m} style={{ fontSize: mobile ? 9 : 12, fontFamily: "'JetBrains Mono', ui-monospace, monospace", color: COLORS.textDim, background: 'rgba(255,255,255,0.05)', padding: '2px 7px', borderRadius: 5 }}>{m}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <Caption>
        One field, many frontiers — all built on the same foundation you just walked through: pixels → features →
        attention → meaning.
      </Caption>
    </div>
  )
}
